import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from '../../contexts/AuthContext';
import { IcHistory } from "../../Icons";
import axios from "axios";
import { Table, Input, Label } from "reactstrap";
import Header from '../../layout/Header/Header';
import moment from 'moment';

function ListadoLogs() {
  const { user } = useContext(AuthContext);
  const URL_LOGS  = process.env.REACT_APP_URL_LOGS;
  const URL_USERS = process.env.REACT_APP_URL_USERS;

  const [logs,                setLogs]                = useState([]);
  const [users,               setUsers]               = useState([]);
  const [selectedFechaInicio, setSelectedFechaInicio] = useState("0");
  const [selectedFechaFin,    setSelectedFechaFin]    = useState("0");
  const [selectedUser,        setSelectedUser]        = useState("0");

  useEffect(() => {
    axios
      .get(URL_LOGS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((response) => setLogs(response.data))
      .catch(() => {});

    axios
      .get(URL_USERS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((response) => setUsers(response.data))
      .catch(() => {});
  }, []);

  return (
    <>
      <Header />
      {user.menu_logs ? (
        <div className="card container col-sm-11">

          {/* ── Page header ──────────────────────────────────────────────── */}
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcHistory style={{ marginRight: 8, color: "#64748b" }} />
                Logs
              </h3>
              <p className="page-subtitle">Registro de actividad del sistema (último mes de información)</p>
            </div>
          </div>

          {/* ── Filtros ──────────────────────────────────────────────────── */}
          <div className="filter-bar">
            <div>
              <Label>Usuario</Label>
              <Input
                bsSize="sm"
                type="select"
                style={{ minWidth: 190 }}
                value={selectedUser}
                onChange={(e) => setSelectedUser(e.target.value)}
              >
                <option value="0">Todos</option>
                {users
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    if (
                      !a.menu_edoCta_Fam &&
                      !a.menu_edoCta_Don &&
                      a.email !== "admin@lynqro.com" &&
                      a.email !== "admin@sistemify.com"
                    ) {
                      return (
                        <option key={a._id} value={a._id}>
                          {a.nombre} {a.apellido}
                        </option>
                      );
                    }
                    return null;
                  })}
              </Input>
            </div>
            <div>
              <Label>Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio === "0" ? "" : selectedFechaInicio}
                onChange={(e) => setSelectedFechaInicio(e.target.value || "0")}
              />
            </div>
            <div>
              <Label>Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin === "0" ? "" : selectedFechaFin}
                onChange={(e) => setSelectedFechaFin(e.target.value || "0")}
              />
            </div>
          </div>

          {/* ── Tabla ────────────────────────────────────────────────────── */}
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Tipo</th>
                <th>Detalle</th>
                <th>Usuario</th>
              </tr>
            </thead>
            <tbody>
              {logs
                .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
                .map((a) => {
                  if (
                    (selectedFechaInicio === "0" || selectedFechaInicio <= a.createdAt.substring(0, 10)) &&
                    (selectedFechaFin    === "0" || selectedFechaFin    >= a.createdAt.substring(0, 10)) &&
                    (selectedUser        === "0" || selectedUser        === a.user[0]?._id)
                  ) {
                    return (
                      <tr key={a._id}>
                        <td>{moment(a.createdAt).utcOffset('-0600').format("YYYY-MM-DD HH:mm:ss")}</td>
                        <td>{a.tipo}</td>
                        <td>{a.detalle}</td>
                        <td>
                          {a.user && a.user.length > 0
                            ? `${a.user[0].nombre} ${a.user[0].apellido}`
                            : a.vecinosFiori && a.vecinosFiori.length > 0
                            ? `${a.vecinosFiori[0].nombre} ${a.vecinosFiori[0].apellido}`
                            : "—"}
                        </td>
                      </tr>
                    );
                  }
                  return null;
                })}
            </tbody>
          </Table>
        </div>
      ) : undefined}
    </>
  );
}

export default ListadoLogs;
